import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

export default function HalvedContentSection({
  leftContent,
  rightContent,
  reverseMobile = false,
}) {
  return (
    <Box
      alignItems="center"
      display="flex"
      gap={6}
      flexDirection={{ xs: reverseMobile ? "column-reverse" : "column", lg: "row" }}
    >
      <Box sx={{ flex: 1, flexShrink: 0 }}>{leftContent}</Box>
      <Box sx={{ flex: 1, flexShrink: 0 }}>{rightContent}</Box>
    </Box>
  );
}

HalvedContentSection.propTypes = {
  leftContent: PropTypes.node.isRequired,
  rightContent: PropTypes.node.isRequired,
  reverseMobile: PropTypes.bool,
};
